import React from 'react';
import { Alert, AlertTitle, Box, LinearProgress } from '@mui/material';
import { RateLimitInfo } from '@/types/keyword';

interface RateLimitAlertProps {
  rateLimitInfo: RateLimitInfo;
}

export const RateLimitAlert: React.FC<RateLimitAlertProps> = ({
  rateLimitInfo,
}) => {
  if (!rateLimitInfo.isRateLimited) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ mt: 2 }}>
      <AlertTitle>요청 제한 대기 중</AlertTitle>
      <Box>
        재시도 {rateLimitInfo.attempt}/{rateLimitInfo.maxAttempts}
        {rateLimitInfo.retryAfterSeconds &&
          ` · ${rateLimitInfo.retryAfterSeconds}초 후 재시도`}
      </Box>
      <Box sx={{ mt: 1, fontSize: '0.875rem', color: 'text.secondary' }}>
        성공: {rateLimitInfo.totalSucceeded} · 제한: {rateLimitInfo.totalRateLimited}
        {rateLimitInfo.lastKeyword && ` · 마지막: ${rateLimitInfo.lastKeyword}`}
      </Box>
      {rateLimitInfo.retryAfterSeconds && (
        <LinearProgress sx={{ mt: 1.5 }} />
      )}
    </Alert>
  );
};
